<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <path
    fill="#ed5564"
    d="M64.541 72.516c0-.552.22-1.083.611-1.474l5.892-5.893a2.082 2.082 0 0 1 2.947 0l18.742 18.744c.814.812.814 2.13 0 2.945l-5.893 5.893a2.086 2.086 0 0 1-2.946 0L65.152 73.987a2.078 2.078 0 0 1-.611-1.471Z"
  />
  <path
    fill="#ccd1d9"
    d="M4.138 18.871a2.105 2.105 0 0 1-.555-1.006L.052 2.552A2.093 2.093 0 0 1 .61.611 2.078 2.078 0 0 1 2.551.054l15.314 3.527c.38.088.728.281 1.004.557l53.647 53.644a2.088 2.088 0 0 1 0 2.949L60.732 72.516a2.083 2.083 0 0 1-2.947 0L4.138 18.871Z"
  />
  <path
    fill="#d6dae1"
    d="M.611.611A2.078 2.078 0 0 1 2.552.054l15.313 3.527c.381.088.729.281 1.004.557l53.647 53.644a2.088 2.088 0 0 1 0 2.949L60.732 72.516a2.083 2.083 0 0 1-2.947 0L4.138 18.871a2.105 2.105 0 0 1-.555-1.006L.052 2.552c-.159-.7.052-1.433.559-1.941Zm1.474 1.472 3.527 15.314 53.646 53.645 11.785-11.786L17.398 5.613 2.085 2.083Z"
  />
  <path
    fill="#aab2bc"
    d="M66.626 66.622a2.086 2.086 0 0 0 0-2.948L28.883 25.935a2.081 2.081 0 0 0-2.945 0 2.08 2.08 0 0 0 0 2.946l37.741 37.741a2.087 2.087 0 0 0 2.947 0Z"
  />
  <path
    fill="#da4453"
    d="M84.912 76.071H67.235l-2.084-2.084a2.077 2.077 0 0 1-.519-2.081h16.113l4.167 4.165Zm-13.006 4.673h17.678l3.148 3.149c.279.279.473.631.559 1.016H76.073l-4.167-4.165Z"
  />
  <path
    fill="#ffce54"
    d="m50.42 76.934 26.517-26.516a2.08 2.08 0 0 1 2.944 0l4.421 4.418a2.083 2.083 0 0 1 0 2.945L57.785 84.298a2.08 2.08 0 0 1-2.946 0l-4.419-4.419a2.083 2.083 0 0 1 0-2.945Zm32.914 14.731c0-2.225.867-4.318 2.44-5.893 3.25-3.25 8.536-3.25 11.786 0a8.286 8.286 0 0 1 2.44 5.893 8.286 8.286 0 0 1-2.44 5.893 8.277 8.277 0 0 1-5.893 2.441 8.277 8.277 0 0 1-5.893-2.441 8.286 8.286 0 0 1-2.44-5.893Z"
  />
  <path
    fill="#f6bb42"
    d="M89.584 91.665a2.084 2.084 0 1 0 4.167 0 2.084 2.084 0 0 0-4.167 0Z"
  />
</svg>
